var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportSent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.618 16H8.5v2h1.118zm6.882-.882V9h-5V4h-7v16h4.882l2 2H6.49c-1.1 0-1.99-.9-1.99-2V4c0-1.1.9-2 2-2h8l6 6v5.118zM16.5 12h-8v2h8z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24 14.697l-7.543 8.04-4.47-4.47 1.568-1.57c1.187 1.187 1.676 1.694 2.863 2.88l6.47-6.47z",
    clipRule: "evenodd"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS42MTggMTZIOC41djJoMS4xMTh6bTYuODgyLS44ODJWOWgtNVY0aC03djE2aDQuODgybDIgMkg2LjQ5Yy0xLjEgMC0xLjk5LS45LTEuOTktMlY0YzAtMS4xLjktMiAyLTJoOGw2IDZ2NS4xMTh6TTE2LjUgMTJoLTh2Mmg4eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Im0yNCAxNC42OTctNy41NDMgOC4wNC00LjQ3LTQuNDcgMS41NjgtMS41N2MxLjE4NyAxLjE4NyAxLjY3NiAxLjY5NCAyLjg2MyAyLjg4bDYuNDctNi40N3oiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export { SvgReportSent as ReactComponent };